export default "__VITE_ASSET__Dp$Hqo_S__"